import Vue from 'vue'
import Vuex from 'vuex'

/* global modules */
import I18NModule from './global/i18n'
import CitiesModule from './global/cities'
import AuthModule from './global/auth'
import UserModule from './global/user'

/* local modules */
import ItineraryModule from './locals/itinerary'
import MagazineModule from './locals/magazine'
import MainModule from './locals/main'
import ProductModule from './locals/product'
import BuyModule from './locals/buy'
import SupportModule from './locals/support'
import MypageModule from './locals/mypage'

Vue.use(Vuex)

export function createStore() {
  return new Vuex.Store({
    modules: {
      /* global modules */
      i18n: I18NModule,
      cities: CitiesModule,
      auth: AuthModule,
      itinerary: ItineraryModule,
      magazine: MagazineModule,
      main: MainModule,
      product: ProductModule,
      buy: BuyModule,
      support: SupportModule,
      mypage: MypageModule,
      user: UserModule,
    },
    plugins: [],
    state: () => ({
      topBanner: 0,
      stickyHeader: false,
      floatingHeader: true,
      visualHeight: 0,
      headerHeight: 0,
      openedSearch: false,
      countryCodes: {},
      terms: [],
      term: {},
      onLive: null,
      topAffiliate: 0,
      userIp: null, // hanalog용
      reservationPathCode: 'DCP', // hanalog용
      refreshExpiredTime: 0, // hanatour X-AUTH 용
    }),
    getters: {
      topBanner: (state) => state.topBanner,
      stickyHeader: (state) => state.stickyHeader,
      floatingHeader: (state) => state.floatingHeader && !state.stickyHeader,
      visualHeight: (state) => state.visualHeight,
      headerHeight: (state) => state.headerHeight,
      openedSearch: (state) => state.openedSearch,
      topAffiliate: (state) => state.topAffiliate,
      refreshExpiredTime: (state) => state.refreshExpiredTime,
    },
    actions: {
      async getTerms({ commit }) {
        try {
          const { data } = await this.$http.post('/user/v1/terms')
          commit('setTerms', data)
        } catch (err) {
          console.log(err)
        }
      },
      async getTerm({ commit }, { groupKey, key }) {
        try {
          const { data } = await this.$http.get(`/user/v1/terms/fulltext/${key}`)
          commit('setTerm', { data, groupKey })
        } catch (err) {
          console.log(err)
        }
      },
      async getCountryCodes({ commit }) {
        try {
          const { data } = await this.$http.get('/platform/v1/options/mobile_country')
          commit('setCountryCodes', data)
        } catch (err) {
          console.log(err)
        }
      },
      setTopBanner: ({ commit }, number) => {
        commit('SET_TOP_BANNER', number)
      },
      setSticky: ({ commit }, bool) => {
        commit('SET_STICKY', bool)
      },
      setFloating: ({ commit }, bool) => {
        commit('SET_FLOATING', bool)
      },
      setVisualHeight: ({ commit }, number) => {
        commit('SET_VISUAL_HEIGHT', number)
      },
      setHeaderHeight: ({ commit }, number) => {
        commit('SET_HEADER_HEIGHT', number)
      },
      setOpenedSearch: ({ commit }, bool) => {
        commit('SET_OPENED_SEARCH', bool)
      },
      setTopAffiliate: ({ commit }, bool) => {
        commit('SET_TOP_AFFILIATE', bool)
      },
    },
    mutations: {
      setTerms(state, data) {
        state.terms = data
      },
      setTerm(state, { data, groupKey }) {
        // const term = _.findIndex(state.terms, term => term.id == typeName);
        state.term = data
      },
      setCountryCodes(state, data) {
        state.countryCodes = data
      },
      SET_TOP_BANNER(state, number) {
        state.topBanner = number
      },
      SET_STICKY(state, bool) {
        state.stickyHeader = bool
      },
      SET_FLOATING(state, bool) {
        state.floatingHeader = bool
      },
      SET_VISUAL_HEIGHT(state, number) {
        state.visualHeight = number
      },
      SET_HEADER_HEIGHT(state, number) {
        state.headerHeight = number
      },
      SET_OPENED_SEARCH(state, bool) {
        state.openedSearch = bool
      },
      SET_TOP_AFFILIATE(state, number) {
        state.topAffiliate = number
      },
      SET_USER_IP(state, ip) {
        state.userIp = ip
      },
      SET_REFRESH_EXPIRED_TIME(state, refreshExpiredTime) {
        state.refreshExpiredTime = refreshExpiredTime
      },
    },
  })
}
